import { z } from 'zod';

import { urlWithoutHttpsRegex } from '../../../helpers/stringHelpers';

export const schema = z.object({
  start: z.date({ error: 'required' }),
  end: z.date({ error: 'required' }),
  recurrenceActive: z.boolean(),
  recurrenceRate: z.enum(['weekly', 'bi-weekly', 'monthly']).optional(),
  recurrenceAmount: z.number().nullable(),
  recurrenceMonthType: z.string().nullable(),
  recurrenceDurationOption: z.string().nullable(),
  eventType: z.enum(['live', 'online', 'secret']),
  venue: z.string().optional().nullable(),
  customVenue: z.string().optional(),
  onlineLink: z
    .union([
      z.literal(''),
      z
        .string()
        .trim()
        .refine((value) => urlWithoutHttpsRegex.test(value), {
          message: 'url-format',
        }),
    ])
    .optional(),
});
// Conditional refinements
export const schemaWithLocationRefinement = schema
  .refine(
    (data) => {
      if (data.eventType !== 'live') {
        return true;
      }

      // Check if the 'venue' field is set and is not '0', 0 is the default venue
      if (data.venue && data.venue !== '0') {
        return true;
      }

      if (data.customVenue && data.customVenue.trim() !== '') {
        return true;
      }

      return false;
    },
    {
      message: 'required',
      path: ['venue'], // Highlight the relevant field
    },
  )
  .refine(
    (data) => {
      if (data.eventType !== 'online') {
        return true;
      }

      if (data?.onlineLink?.trim() !== '') {
        return true;
      }
    },
    {
      message: 'required',
      path: ['onlineLink'],
    },
  );
